import validate from "/home/archerist/nuxt3_ogrenci/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/archerist/nuxt3_ogrenci/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/archerist/nuxt3_ogrenci/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.mjs")
}